export default {"src":"/_next/static/media/arrow-down.f7a1278b.svg","height":9,"width":16};